import trimHtml from 'trim-html';

import decodeString from 'hb-react/shared/utils/decodeString';

interface Opts {
  limit: number;
  suffix?: string;
  preserveTags?: boolean;
  // @deprecated
  moreLink?: string;
  moreText?: string;
  preserveWhiteSpace?: boolean;
}

interface ReturnType {
  html: string;
  more: boolean;
}

export const truncateHtmlAt = (
  source: string,
  limit?: number,
  opts?: Opts,
): ReturnType => {
  if (!limit) {
    return {
      html: source,
      more: false,
    };
  }

  return trimHtml(decodeString(source), {
    limit,
    ...opts,
  });
};
